/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PayerInfo/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Discount from './Discount/index'
import Downpayment from './Downpayment/index'
import Installment from './Installment/index'
import Payer from './Payer/index'
import React from 'react'
import Total from './Total/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'



/** @type {import('Simple/types.js').View} */
export default function PayerInfo({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<Payer
  viewPath={`${viewPath}/Payer`}
/>
<Downpayment
  viewPath={`${viewPath}/Downpayment`}
/>
<Discount
  viewPath={`${viewPath}/Discount`}
/>
<Installment
  viewPath={`${viewPath}/Installment`}
/>
<Total
  viewPath={`${viewPath}/Total`}
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={dtSpaceM}
 marginTop={0}
 backgroundColor={dtColorsNeutral300}
/>
{children}
</React.Fragment>)
}